import { FC } from 'react';
import { Outlet } from 'react-router-dom';
import { AppBar, Box, Drawer } from '@mui/material';
import VerticalTabs from '../../Navigator/Tabs/VerticalTabs';
import { IPanelLinks } from 'src/models/IPanelLinks';

interface IProps {
  links: IPanelLinks[];
}

const MainLayout: FC<IProps> = ({ links }) => {
  return (
    <>
      <Drawer variant='permanent' anchor='left'>
        <div className='logo abbr'>SR</div>
        <VerticalTabs links={links} />
      </Drawer>
      <Box
        component='main'
        className='active'
        sx={{ margin: '0 0 0 auto', padding: '16px', minHeight: '100vh' }}
      >
        <Outlet />
      </Box>
    </>
  );
};

export default MainLayout;
